export const addCommas = (value, digits = 2) => {
  if (value) {
    const result = value.toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: 4,
    });
    return result;
  }
  return '0';
};
export default addCommas;
